import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const WEB3FORMS_KEY = "f3aa79b4-b6a6-4351-9003-a1996b0d7cd4";

/* ════════════════════════════════════
   KEYFRAMES
════════════════════════════════════ */
const STYLES = `
  @keyframes cPing  { 0%{transform:scale(1);opacity:.65} 100%{transform:scale(2.4);opacity:0} }
  @keyframes cBlink { 0%,100%{opacity:1} 50%{opacity:.2} }
  @keyframes cShim  { 0%{background-position:200% center} 100%{background-position:-200% center} }
  @keyframes cFloat { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-5px)} }
`;

/* ════════════════════════════════════
   PREMIUM SVG ICONS — no emojis
════════════════════════════════════ */
const IconMail = ({ size = 22, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="3" />
    <path d="M2 7.5l10 6.5 10-6.5" />
  </svg>
);

const IconTelegram = ({ size = 22, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 4L3.9 10.6c-.9.4-.9 1.6 0 2l4.2 1.5 1.5 4.2c.4.9 1.6.9 2 0L21 4z" />
    <path d="M8.1 14.1L21 4" />
  </svg>
);

const IconWhatsApp = ({ size = 22, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148
      -.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15
      -1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018
      -.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099
      -.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487
      -.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297
      -1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096
      3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118
      .571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124
      -.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361
      -.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45
      4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0
      012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815
      11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142
      1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005
      c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const IconArrow = ({ size = 14, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);

const IconCheck = ({ size = 11, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 6L9 17l-5-5" />
  </svg>
);

const IconSend = ({ size = 16, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="22" y1="2" x2="11" y2="13" />
    <polygon points="22 2 15 22 11 13 2 9 22 2" />
  </svg>
);

/* ════════════════════════════════════
   CONTACT METHODS DATA
════════════════════════════════════ */
const CONTACTS = [
  {
    id: "email",
    Icon: IconMail,
    label: "Email Us",
    value: "nyxlabsweb@gmail.com",
    sub: "Reply within 24 hours",
    color: "#7c3aed",
    href: "mailto:nyxlabsweb@gmail.com",
    action: "Send Email",
    isWA: true,
  },
  {
    id: "phone",
    Icon: IconTelegram,
    label: "Join Our Community",
    value: "@nyxlabsofficial",
    sub: "Join us on Telegram",
    color: "#a855f7",
    href: "https://t.me/nyxlabsofficial",
    action: "Join Now",
    isWA: true,
  },
  {
    id: "whatsapp",
    Icon: IconWhatsApp,
    label: "WhatsApp",
    value: "+91 9878502708",
    sub: "Instant response guaranteed",
    color: "#25d366",
    href: "https://wa.me/919878502708",
    action: "Chat Now",
    isWA: true,
  },
];

/* ════════════════════════════════════
   CONTACT CARD
════════════════════════════════════ */
function ContactCard({ c, i }) {
  const [hov, setHov] = useState(false);
  const [clicked, setClicked] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.55, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}>
      <a href={c.href} target={c.isWA ? "_blank" : undefined}
        rel={c.isWA ? "noreferrer" : undefined}
        style={{ textDecoration: "none", display: "block" }}
        onClick={() => { setClicked(true); setTimeout(() => setClicked(false), 500); }}>
        <div
          onMouseEnter={() => setHov(true)}
          onMouseLeave={() => setHov(false)}
          style={{
            padding: "32px 28px", borderRadius: 22, cursor: "pointer",
            background: hov
              ? `linear-gradient(145deg,${c.color}0d,rgba(255,255,255,0.04))`
              : "rgba(255,255,255,0.025)",
            border: `1px solid ${hov ? c.color + "55" : "rgba(124,58,237,0.13)"}`,
            boxShadow: hov ? `0 16px 52px ${c.color}1e` : "none",
            transform: hov ? "translateY(-8px)" : "translateY(0)",
            transition: "all 0.35s cubic-bezier(0.16,1,0.3,1)",
            willChange: "transform", position: "relative", overflow: "hidden",
          }}>

          {/* Top glow strip */}
          <div style={{
            position: "absolute", top: 0, left: 0, right: 0, height: 1, pointerEvents: "none",
            background: `linear-gradient(90deg,transparent,${c.color}cc,transparent)`,
            opacity: hov ? 1 : 0, transition: "opacity 0.35s ease",
          }} />

          {/* Corner brackets */}
          <div style={{
            position: "absolute", top: 0, right: 0, width: 36, height: 36, pointerEvents: "none",
            borderTop: `2px solid ${c.color}`, borderRight: `2px solid ${c.color}`,
            borderRadius: "0 20px 0 0",
            opacity: hov ? 1 : 0, transform: hov ? "scale(1)" : "scale(0.3)",
            transition: "all 0.28s cubic-bezier(0.16,1,0.3,1)",
          }} />
          <div style={{
            position: "absolute", bottom: 0, left: 0, width: 36, height: 36, pointerEvents: "none",
            borderBottom: `2px solid ${c.color}`, borderLeft: `2px solid ${c.color}`,
            borderRadius: "0 0 0 20px",
            opacity: hov ? 1 : 0, transform: hov ? "scale(1)" : "scale(0.3)",
            transition: "all 0.28s cubic-bezier(0.16,1,0.3,1)",
          }} />

          {/* Ambient top glow */}
          <div style={{
            position: "absolute", top: -44, left: "50%", transform: "translateX(-50%)",
            width: 150, height: 150, borderRadius: "50%", pointerEvents: "none",
            background: `radial-gradient(circle,${c.color}28,transparent 70%)`,
            opacity: hov ? 1 : 0, transition: "opacity 0.35s ease",
          }} />

          {/* Icon box with ping ring */}
          <div style={{ position: "relative", display: "inline-flex", marginBottom: 20 }}>
            <div style={{
              width: 56, height: 56, borderRadius: 16,
              background: `linear-gradient(135deg,${c.color}22,${c.color}09)`,
              border: `1px solid ${c.color}35`,
              display: "flex", alignItems: "center", justifyContent: "center",
              color: c.color,
              boxShadow: hov ? `0 0 28px ${c.color}55` : "none",
              animation: hov ? "cFloat 2.4s ease-in-out infinite" : "none",
              willChange: "transform",
              transition: "box-shadow 0.35s ease",
            }}>
              <c.Icon size={24} color={c.color} />
            </div>
            {/* Ping ring on hover */}
            {hov && (
              <div style={{
                position: "absolute", inset: 0, borderRadius: 16,
                border: `1px solid ${c.color}`,
                animation: "cPing 1.6s ease-out infinite",
                willChange: "transform,opacity",
              }} />
            )}
          </div>

          {/* Label */}
          <div style={{
            fontFamily: "'DM Sans',sans-serif", fontSize: 11, fontWeight: 600,
            color: c.color, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 8,
          }}>{c.label}</div>

          {/* Value — shimmer on hover */}
          <div style={{
            fontFamily: "'Syne',sans-serif", fontWeight: 700,
            fontSize: "clamp(13px,1.8vw,16px)", marginBottom: 6,
            ...(hov ? {
              background: `linear-gradient(90deg,${c.color},#e879f9,${c.color})`,
              backgroundSize: "200% auto",
              WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              animation: "cShim 2s linear infinite",
            } : { color: "#f1f0f5" }),
          }}>{c.value}</div>

          {/* Sub */}
          <div style={{
            fontFamily: "'DM Sans',sans-serif", fontSize: 12,
            color: "rgba(241,240,245,0.42)", marginBottom: 22,
          }}>{c.sub}</div>

          {/* Action pill */}
          <div style={{
            display: "inline-flex", alignItems: "center", gap: 8,
            padding: "8px 16px", borderRadius: 10,
            background: `${c.color}15`, border: `1px solid ${c.color}30`,
            fontFamily: "'DM Sans',sans-serif", fontSize: 13, fontWeight: 600,
            color: c.color,
            transform: hov ? "translateX(5px)" : "translateX(0)",
            transition: "transform 0.3s ease",
          }}>
            {/* Live dot */}
            <span style={{
              width: 6, height: 6, borderRadius: "50%",
              background: c.color, boxShadow: `0 0 6px ${c.color}`,
              display: "block",
              animation: "cBlink 2s ease-in-out infinite", willChange: "opacity",
            }} />
            {c.action}
            <IconArrow size={13} color={c.color} />
          </div>

          {/* Click ripple */}
          <AnimatePresence>
            {clicked && (
              <motion.div
                initial={{ scale: 0, opacity: 0.4 }}
                animate={{ scale: 3.5, opacity: 0 }}
                exit={{}}
                transition={{ duration: 0.5 }}
                style={{
                  position: "absolute", top: "50%", left: "50%",
                  width: 60, height: 60, borderRadius: "50%",
                  background: c.color, marginTop: -30, marginLeft: -30,
                  pointerEvents: "none",
                }} />
            )}
          </AnimatePresence>
        </div>
      </a>
    </motion.div>
  );
}

/* ════════════════════════════════════
   TOAST
════════════════════════════════════ */
function Toast({ message, type, onClose }) {
  return (
    <motion.div
      className="contact-toast"
      initial={{ opacity: 0, y: 60, scale: 0.9 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 60, scale: 0.9 }}
      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
      style={{
        position: "fixed", bottom: 32, right: 32, zIndex: 9999,
        padding: "16px 24px", borderRadius: 14, backdropFilter: "blur(20px)",
        background: type === "success"
          ? "linear-gradient(135deg,rgba(34,197,94,.18),rgba(16,185,129,.12))"
          : "linear-gradient(135deg,rgba(244,63,94,.18),rgba(239,68,68,.12))",
        border: type === "success"
          ? "1px solid rgba(34,197,94,.35)" : "1px solid rgba(244,63,94,.35)",
        display: "flex", alignItems: "center", gap: 12,
        maxWidth: 400, boxShadow: "0 16px 48px rgba(0,0,0,.5)",
      }}>
      <span style={{ fontSize: 20, color: type === "success" ? "#86efac" : "#fca5a5" }}>
        {type === "success" ? "✓" : "✕"}
      </span>
      <p style={{
        fontFamily: "'DM Sans',sans-serif", fontSize: 14, fontWeight: 500,
        color: type === "success" ? "#86efac" : "#fca5a5", lineHeight: 1.5, margin: 0,
      }}>{message}</p>
      <button onClick={onClose} style={{
        marginLeft: "auto", background: "none", border: "none",
        cursor: "pointer", color: "rgba(241,240,245,.5)", fontSize: 20, padding: "0 0 0 8px",
      }}>×</button>
    </motion.div>
  );
}

/* ════════════════════════════════════
   FORM FIELD
════════════════════════════════════ */
function Field({ label, type = "text", name, value, onChange, error, placeholder, multiline, rows = 5 }) {
  const [focused, setFocused] = useState(false);
  const style = {
    width: "100%", padding: "14px 18px", borderRadius: 12, outline: "none",
    fontFamily: "'DM Sans',sans-serif", fontSize: 14, color: "#f1f0f5",
    transition: "all .28s ease", resize: multiline ? "vertical" : "none",
    minHeight: multiline ? `${rows * 24 + 28}px` : "auto",
    background: focused ? "rgba(124,58,237,.08)" : "rgba(255,255,255,.025)",
    border: error
      ? "1px solid rgba(244,63,94,.55)"
      : focused ? "1px solid rgba(124,58,237,.6)" : "1px solid rgba(124,58,237,.18)",
    boxShadow: focused ? "0 0 0 3px rgba(124,58,237,.1)" : "none",
  };
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <label style={{
        fontFamily: "'DM Sans',sans-serif", fontSize: 12, fontWeight: 600,
        letterSpacing: "0.08em", textTransform: "uppercase", transition: "color .22s ease",
        color: error ? "#f87171" : focused ? "#c084fc" : "rgba(241,240,245,.5)",
      }}>{label}</label>
      {multiline
        ? <textarea name={name} value={value} onChange={onChange} placeholder={placeholder}
            rows={rows} style={style}
            onFocus={() => setFocused(true)} onBlur={() => setFocused(false)} />
        : <input type={type} name={name} value={value} onChange={onChange} placeholder={placeholder}
            style={style}
            onFocus={() => setFocused(true)} onBlur={() => setFocused(false)} />}
      <AnimatePresence>
        {error && (
          <motion.span initial={{ opacity: 0, y: -4 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}
            style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 12, color: "#f87171" }}>
            ⚠ {error}
          </motion.span>
        )}
      </AnimatePresence>
    </div>
  );
}

/* ════════════════════════════════════
   MAIN PAGE
════════════════════════════════════ */
export default function Contact() {
  const empty = { name: "", email: "", phone: "", subject: "", message: "" };
  const [form, setForm]     = useState(empty);
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("idle");
  const [toast, setToast]   = useState(null);

  const validate = () => {
    const e = {};
    if (!form.name.trim())    e.name    = "Name is required";
    if (!form.email.trim())   e.email   = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = "Enter a valid email";
    if (!form.phone.trim())   e.phone   = "Phone number is required";
    else if (!/^[\d\s+\-().]{7,15}$/.test(form.phone))       e.phone = "Enter a valid phone number";
    if (!form.message.trim()) e.message = "Message is required";
    else if (form.message.trim().length < 20)                  e.message = "At least 20 characters";
    return e;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(p => ({ ...p, [name]: value }));
    if (errors[name]) setErrors(p => ({ ...p, [name]: "" }));
  };

  const pop = (type, message) => {
    setToast({ type, message });
    setTimeout(() => setToast(null), 6000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const v = validate();
    if (Object.keys(v).length) { setErrors(v); return; }
    setStatus("loading");
    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          access_key: WEB3FORMS_KEY,
          subject: form.subject
            ? `[NyxLabs] ${form.subject}`
            : `[NyxLabs] Message from ${form.name}`,
          from_name: "NyxLabs Contact Form",
          replyto: form.email,
          name: form.name, email: form.email,
          phone: form.phone, message: form.message,
          botcheck: "",
        }),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setForm(empty); setStatus("success");
        pop("success", "Message sent! We'll get back to you within 24 hours 🚀");
      } else {
        const apiMessage = data.message || data.body?.message || `Web3Forms returned HTTP ${res.status}`;
        console.error("Web3Forms submission failed:", { status: res.status, data });
        throw new Error(apiMessage);
      }
    } catch (err) {
      setStatus("error");
      pop("error", err.message || "Something went wrong. Email us at nyxlabsweb@gmail.com");
    } finally { setStatus("idle"); }
  };

  return (
    <>
      <style>{STYLES}</style>
      <div className="contact-page" style={{ minHeight: "100vh", padding: "120px 60px 80px", maxWidth: 1200, margin: "0 auto" }}>

        {/* ── HEADER ── */}
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }} transition={{ duration: 0.7 }}
          style={{ textAlign: "center", marginBottom: 72 }}>
          <div style={{
            display: "inline-flex", alignItems: "center", gap: 8, padding: "6px 16px",
            borderRadius: 100, background: "rgba(124,58,237,0.1)",
            border: "1px solid rgba(124,58,237,0.25)", marginBottom: 20,
          }}>
            <span style={{
              width: 6, height: 6, borderRadius: "50%", background: "#a855f7",
              boxShadow: "0 0 8px #a855f7", display: "block",
              animation: "cBlink 2s ease-in-out infinite",
            }} />
            <span style={{
              fontSize: 11, fontFamily: "'DM Sans',sans-serif", fontWeight: 500,
              color: "#c084fc", letterSpacing: "0.1em", textTransform: "uppercase",
            }}>Get In Touch</span>
          </div>
          <h1 style={{
            fontFamily: "'Syne',sans-serif", fontWeight: 800,
            fontSize: "clamp(38px,6vw,62px)", lineHeight: 1.05, letterSpacing: "-0.02em",
            color: "#f1f0f5", marginBottom: 16,
          }}>
            Connect With{" "}
            <span style={{
              background: "linear-gradient(135deg,#a855f7,#e879f9)",
              WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}>NyxLabs</span>
          </h1>
          <p style={{
            fontFamily: "'DM Sans',sans-serif", fontWeight: 300, fontSize: 17,
            color: "rgba(241,240,245,0.5)", maxWidth: 480, margin: "0 auto", lineHeight: 1.75,
          }}>
            Ready to build something dark and powerful? Reach out — we're always in the void.
          </p>
        </motion.div>

        {/* ── CONTACT METHOD CARDS ── */}
        <div className="contact-method-grid" style={{
          display: "grid", gridTemplateColumns: "repeat(3,1fr)",
          gap: 20, marginBottom: 64,
        }}>
          {CONTACTS.map((c, i) => <ContactCard key={c.id} c={c} i={i} />)}
        </div>

        {/* ── AVAILABILITY STRIP ── */}
        <motion.div initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.3 }}
          style={{
            padding: "14px 24px", borderRadius: 14, marginBottom: 52,
            background: "rgba(37,211,102,0.06)", border: "1px solid rgba(37,211,102,0.2)",
            display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap",
          }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div style={{ position: "relative", width: 10, height: 10 }}>
              <div style={{
                width: 10, height: 10, borderRadius: "50%",
                background: "#25d366", boxShadow: "0 0 8px #25d366",
              }} />
              <div style={{
                position: "absolute", inset: 0, borderRadius: "50%",
                border: "1px solid #25d366",
                animation: "cPing 2s ease-out infinite",
              }} />
            </div>
            <span style={{
              fontFamily: "'DM Sans',sans-serif", fontSize: 13, fontWeight: 600, color: "#25d366",
            }}>Available Now</span>
          </div>
          <span style={{
            fontFamily: "'DM Sans',sans-serif", fontSize: 13,
            color: "rgba(241,240,245,0.45)",
          }}>
            Mon – Sat · 10:00 AM – 7:00 PM IST · Fastest response via WhatsApp
          </span>
        </motion.div>

        {/* ── FORM CARD ── */}
        <motion.div className="contact-form-card" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }} transition={{ duration: 0.7, delay: 0.2 }}
          style={{
            padding: "52px 56px", borderRadius: 28,
            background: "rgba(255,255,255,0.02)", border: "1px solid rgba(124,58,237,0.15)",
            position: "relative", overflow: "hidden",
          }}>
          <div style={{
            position: "absolute", top: -80, right: -80, width: 300, height: 300,
            borderRadius: "50%",
            background: "radial-gradient(circle,rgba(124,58,237,0.07) 0%,transparent 70%)",
            pointerEvents: "none",
          }} />

          <div className="contact-grid">
            {/* Left */}
            <div>
              <h2 style={{
                fontFamily: "'Syne',sans-serif", fontWeight: 700, fontSize: 26,
                color: "#f1f0f5", marginBottom: 14, lineHeight: 1.25,
              }}>Send a Message</h2>
              <p style={{
                fontFamily: "'DM Sans',sans-serif", fontSize: 14, lineHeight: 1.8,
                color: "rgba(241,240,245,0.45)", marginBottom: 28,
              }}>
                Fill the form and we'll reply within 24 hours — or reach out directly via the contact methods above.
              </p>

              {/* Trust points */}
              {["Fast Response Time", "No Spam. Ever.", "Professional & Discreet"].map((t, i) => (
                <motion.div key={i}
                  initial={{ opacity: 0, x: -16 }} whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.1 }}
                  style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
                  <div style={{
                    width: 22, height: 22, borderRadius: 6, flexShrink: 0,
                    background: "rgba(124,58,237,0.2)", border: "1px solid rgba(124,58,237,0.3)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                  }}>
                    <IconCheck size={11} color="#a855f7" />
                  </div>
                  <span style={{
                    fontFamily: "'DM Sans',sans-serif", fontSize: 14,
                    color: "rgba(241,240,245,0.6)",
                  }}>{t}</span>
                </motion.div>
              ))}

              {/* Compact contact links */}
              <div style={{ marginTop: 32, display: "flex", flexDirection: "column", gap: 10 }}>
                {CONTACTS.map((c, i) => (
                  <motion.a key={c.id} href={c.href}
                    target={c.isWA ? "_blank" : undefined}
                    rel={c.isWA ? "noreferrer" : undefined}
                    initial={{ opacity: 0, x: -10 }} whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }} transition={{ duration: 0.4, delay: 0.3 + i * 0.08 }}
                    whileHover={{ x: 4 }}
                    style={{
                      display: "flex", alignItems: "center", gap: 10,
                      textDecoration: "none", padding: "10px 14px", borderRadius: 10,
                      background: "rgba(255,255,255,0.03)", border: `1px solid ${c.color}22`,
                      transition: "all 0.25s ease",
                    }}
                    onMouseEnter={e => {
                      e.currentTarget.style.background = `${c.color}10`;
                      e.currentTarget.style.borderColor = `${c.color}40`;
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.background = "rgba(255,255,255,0.03)";
                      e.currentTarget.style.borderColor = `${c.color}22`;
                    }}>
                    <span style={{ color: c.color, display: "flex", alignItems: "center" }}>
                      <c.Icon size={16} color={c.color} />
                    </span>
                    <div>
                      <div style={{
                        fontFamily: "'DM Sans',sans-serif", fontSize: 10, fontWeight: 600,
                        color: c.color, letterSpacing: "0.08em", textTransform: "uppercase",
                      }}>{c.label}</div>
                      <div style={{
                        fontFamily: "'Syne',sans-serif", fontWeight: 600,
                        fontSize: 13, color: "#f1f0f5",
                      }}>{c.value}</div>
                    </div>
                    <span style={{ marginLeft: "auto", color: c.color, display: "flex" }}>
                      <IconArrow size={13} color={c.color} />
                    </span>
                  </motion.a>
                ))}
              </div>
            </div>

            {/* Right — Form */}
            <form onSubmit={handleSubmit} noValidate
              style={{ display: "flex", flexDirection: "column", gap: 18 }}>
              <div className="two-col">
                <Field label="Full Name *"     name="name"    value={form.name}    onChange={handleChange} error={errors.name}    placeholder="John Doe" />
                <Field label="Email Address *" name="email"   value={form.email}   onChange={handleChange} error={errors.email}   placeholder="you@example.com" type="email" />
              </div>
              <div className="two-col">
                <Field label="Phone Number *"  name="phone"   value={form.phone}   onChange={handleChange} error={errors.phone}   placeholder="+91 98765 43210" type="tel" />
                <Field label="Subject"         name="subject" value={form.subject} onChange={handleChange} placeholder="Project / Collab / Other" />
              </div>
              <Field label="Message *" name="message" value={form.message} onChange={handleChange}
                error={errors.message} placeholder="Tell us about your project, timeline and goals…"
                multiline rows={5} />
              <input type="checkbox" name="botcheck" style={{ display: "none" }} />

              <motion.button type="submit" disabled={status === "loading"}
                whileHover={status !== "loading"
                  ? { scale: 1.02, boxShadow: "0 0 40px rgba(124,58,237,.5)" } : {}}
                whileTap={status !== "loading" ? { scale: 0.97 } : {}}
                style={{
                  padding: "15px 32px", borderRadius: 12,
                  cursor: status === "loading" ? "not-allowed" : "pointer",
                  background: status === "loading"
                    ? "rgba(124,58,237,.4)" : "linear-gradient(135deg,#7c3aed,#a855f7)",
                  border: "none", color: "#fff",
                  fontFamily: "'DM Sans',sans-serif", fontWeight: 600, fontSize: 15,
                  display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
                  boxShadow: "0 0 24px rgba(124,58,237,.3)", transition: "all .28s ease",
                }}>
                {status === "loading" ? (
                  <>
                    <motion.span animate={{ rotate: 360 }}
                      transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
                      style={{
                        display: "block", width: 16, height: 16,
                        border: "2px solid rgba(255,255,255,.3)",
                        borderTopColor: "#fff", borderRadius: "50%",
                      }} />
                    Sending…
                  </>
                ) : (
                  <>
                    Send Message
                    <IconSend size={15} color="#fff" />
                  </>
                )}
              </motion.button>
            </form>
          </div>
        </motion.div>
      </div>

      <AnimatePresence>
        {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
      </AnimatePresence>

      <style>{`
        .contact-grid { display:grid; grid-template-columns:1fr 1.5fr; gap:56px; align-items:start; }
        .two-col      { display:grid; grid-template-columns:1fr 1fr; gap:16px; }
        @media (max-width: 1100px) {
          .contact-method-grid { grid-template-columns: repeat(2, 1fr) !important; }
        }
        @media (max-width: 900px) {
          .contact-page { padding: 110px 30px 70px !important; }
          .contact-grid { grid-template-columns: 1fr !important; gap: 32px !important; }
          .contact-method-grid { grid-template-columns: 1fr !important; }
        }
        @media (max-width: 560px) {
          .contact-page { padding: 100px 20px 60px !important; }
          .two-col { grid-template-columns: 1fr !important; }
          .contact-form-card { padding: 28px 20px !important; }
          .contact-toast {
            left: 12px !important;
            right: 12px !important;
            bottom: 14px !important;
            max-width: none !important;
          }
        }
        textarea,input[type=text],input[type=email],input[type=tel]{color:#f1f0f5!important}
        textarea::placeholder,input::placeholder{color:rgba(168,165,184,.4)!important}
      `}</style>
    </>
  );
}
